'use client'

import React, { ReactElement, ReactNode } from 'react'
import { TabButton, TabList, TabPanels } from '../uiComponents'

export interface TabContentProps {
	children: ReactNode
	infoPanel?: ReactNode
	button: ReactNode
}

export const TabContent = (props: TabContentProps) => {
	return <>{props.children}</>
}

interface TabsProps {
	variant?: 'full' | 'button'
	children: ReactElement<TabContentProps> | Array<ReactElement<TabContentProps>>
	tabListClassName?: string
	tabListNearElement?: ReactNode
	tabListNoWrap?: boolean
	activeIndex: number
	onActiveIndexChanged?: (index: number) => void
}

export const ControlledTabs = (props: Omit<TabsProps, 'activeIndex'>) => {
	const [activeIndex, setActiveIndex] = React.useState(0)
	return (
		<Tabs
			{...props}
			activeIndex={activeIndex}
			onActiveIndexChanged={(index) => {
				setActiveIndex(index)
				props.onActiveIndexChanged?.(index)
			}}
		/>
	)
}

export const Tabs = (props: TabsProps) => {
	const tabs = Array.isArray(props.children) ? props.children : [props.children]

	const handleTabButtonClick = (index: number) => {
		props.onActiveIndexChanged?.(index)
	}

	return (
		<div className="flex flex-col w-full h-full">
			{/* Tab Navigation */}
			<div className="flex w-full justify-between items-center">
				<TabList className={props.tabListClassName} nowrap={props.tabListNoWrap}>
					{tabs.map((tab, index) => {
						const content = tab as ReactElement<TabContentProps>
						return (
							<>
								<TabButton key={index} variant={props.variant} isActive={props.activeIndex === index} onClick={() => handleTabButtonClick(index)}>
									{content.props.button}
								</TabButton>
								{tab.props.infoPanel && (tab.props.infoPanel as React.ReactElement)}
							</>
						)
					})}
				</TabList>
				{props.tabListNearElement}
			</div>

			{/* Tab Panels */}
			<TabPanels activeIndex={props.activeIndex}>
				{tabs.map((tab, index) => (
					<React.Fragment key={index}>{tab}</React.Fragment>
				))}
			</TabPanels>
		</div>
	)
}
